export const AccountActions = {
  // Checklist keys

  GET_USER_ACCOUNT_DETAILS_LIST: "GET_USER_ACCOUNT_DETAILS_LIST",
  SET_USER_ACCOUNT_DETAILS_LIST: "SET_USER_ACCOUNT_DETAILS_LIST",

  UPDATE_USER_ACCOUNT_DETAILS: "UPDATE_USER_ACCOUNT_DETAILS",
  UPDATE_USER_ACCOUNT_PASSWORD: "UPDATE_USER_ACCOUNT_PASSWORD",

  IS_OPEN_MODELS_EDIT_USER_ACCOUNT_PASSWORD:
    "IS_OPEN_MODELS_EDIT_USER_ACCOUNT_PASSWORD",

  // define other action types here
};
